







































import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Confluence"
})
export default class Confluence extends Vue {}
